import actionTypes from '../constants/actionTypes'

export default function editorialReducer(state = {}, action) {
  switch(action.type) {
    case actionTypes.GET_EDITORIAL:
      return Object.assign({}, state, {
        editorialItems : action.data.editorialItems,
        heading: 'Editorial'
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/editorial.js